module.exports = __webpack_public_path__ + "static/media/logo-gmcn.e21a0833.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/Dashboard/Partners/images/logo-gmcn.png
// module id = 1098
// module chunks = 1